import { whenZero } from '@execonline-inc/numbers';
import { always } from '@kofno/piper';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import PreviouslyAllocated from './PreviouslyAllocated';

export interface Props {
  productLicensePublicName: string;
  activationsRemaining: number;
  newLicenseAllocations: number;
}

function InviteMore({
  activationsRemaining,
  newLicenseAllocations,
  productLicensePublicName,
}: Props) {
  return (
    <div className="bg-teal-50 border-1 border-teal-400 rounded">
      <p className="text-sm p-3">
        {just(newLicenseAllocations)
          .andThen(whenZero)
          .map(
            always(
              <>
                <T kind="Invite more participants!" />{' '}
                <PreviouslyAllocated
                  productLicensePublicName={productLicensePublicName}
                  activationsRemaining={activationsRemaining}
                />
              </>,
            ),
          )
          .getOrElse(
            always(
              <>
                <T kind="Invite more participants!" />{' '}
                <T
                  kind="There is <span>{{count}} license activation</span> remaining for {{name}}."
                  span={(content) => <span className="font-bold">{content}</span>}
                  count={activationsRemaining}
                  name={productLicensePublicName}
                />{' '}
              </>,
            ),
          )}
      </p>
    </div>
  );
}

export default observer(InviteMore);
